<template>
    <b-container>
        <b-row style="margin-top:50px">
            <b-col>
                <h4>Invoices</h4>
            </b-col>
        </b-row>
        <!-- Invoices table -->
        <b-row v-if="invoicesArray.length<1">
            <b-col>No invoices found</b-col>
        </b-row>

        <b-row  v-if="invoicesArray.length>0">
            <table class="table table-striped">
                <thead class="thead-dark">
                    <tr>
                        <th>Date</th>
                        <th>From</th>
                        <th>Number</th>
                        <th>Cost</th>
                        <th>Paid?</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="invoice in invoicesArray" :key="invoice.invoicenumber" style="cursor:pointer" @click="showInvoiceNumber(invoice.invoicenumber, invoice)">
                        <td>{{invoice.date.date}} {{invoice.date.month}}</td>
                        <td>{{invoice.brewer}}</td>
                        <td><small>{{invoice.invoicenumber}}</small></td>
                        <td>${{invoice.total}}</td>
                        <td v-if="invoice.paid==1">Yes</td>
                        <td v-else>No</td>
                    </tr>
                </tbody>
            </table>
        </b-row>
        
    </b-container>
</template>

<script>
    import { mapState } from 'vuex'
    const fb = require('../../firebaseConfig.js')
    import {timeConverterObject} from '../Myfunctions'
    export default {
        components: {
            },
        computed: {
            ...mapState(['userProfile', 'currentUser'])
        },
        data() {
            return {
                invoicesArray:[],
                }
        },
        methods:{
            getUserInvoices(){
                fb.invoicesCollection.where('pubid', '==', this.currentUser.uid).orderBy("createdOn", "desc").get().then(docs => {
                    this.loadingPage=false
                    docs.forEach(doc => {
                        let invoice = doc.data()
                        invoice.docId = doc.id
                        invoice.date = timeConverterObject(invoice.createdOn.seconds)
                        this.invoicesArray.push(invoice)
                    })
                }).then(res => {
                })
            },
            showInvoiceNumber(invoicenumber){
                this.$router.push({ path: 'showinvoice', query: { invoicenumber: invoicenumber , invoicedocid: invoice.docId }})
            }
        },

        mounted(){
            this.getUserInvoices()
        }

        
    }
</script>